export const CPTS_FIELD: any = {
  id: "ID",
  auditArea: "AUDIT_AREA",
  auditSubArea: "AUDIT_SUB_AREA",
  cluster: "LEVEL_ONE_CLUSTER",
  internalAuditDomain: "LEVEL_ONE_INTERNAL_AUDIT_DOMAIN",
  code: "LEVEL_ONE_PROCESS_CODE",
  name: "LEVEL_ONE_PROCESS_NAME",
  processStatus: "LEVEL_ONE_PROCESS_STATUS",
  valueChain: "LEVEL_THREE_ID_FOR_SORT",
  valueChainBackup: "LEVEL_ONE_VALUE_CHAIN",
  null: null
  // parent: "PARENT",
  // subNodes: "SUB_NODES",
};

// export const CPTS_FIELD: any = {
//   id: "ID",
//   auditArea: "AUDIT_AREA",
//   auditSubArea: "AUDIT_SUB_AREA",
//   cluster: ['LEVEL_ONE_CLUSTER', 'LEVEL_TWO_CLUSTER', 'LEVEL_THREE_CLUSTER'],
//   internalAuditDomain: ['LEVEL_ONE_INTERNAL_AUDIT_DOMAIN', 'LEVEL_TWO_INTERNAL_AUDIT_DOMAIN', 'LEVEL_THREE_INTERNAL_AUDIT_DOMAIN',],
//   processCode: ['LEVEL_ONE_PROCESS_CODE', 'LEVEL_TWO_PROCESS_CODE', 'LEVEL_THREE_PROCESS_CODE'],
//   name: ['LEVEL_ONE_PROCESS_NAME', 'LEVEL_TWO_PROCESS_NAME', 'LEVEL_THREE_PROCESS_NAME'],
//   processStatus: ['LEVEL_ONE_PROCESS_STATUS', 'LEVEL_TWO_PROCESS_STATUS', 'LEVEL_THREE_PROCESS_STATUS'],
//   valueChain: ['LEVEL_ONE_VALUE_CHAIN', 'LEVEL_TWO_VALUE_CHAIN', 'LEVEL_THREE_VALUE_CHAIN'],
//   orderId: "LEVEL_THREE_ID_FOR_SORT",
//   valueChainBackup: "LEVEL_ONE_VALUE_CHAIN",
//   null: null
//   // parent: "PARENT",
//   // subNodes: "SUB_NODES",
// };